export const it = {
    action: {
        goIt: "Entra",
    },
    msg: {
        emptyApp:
            "Nessuna Applicazione disponibile. Contattare l'amministrazione, grazie.",
    },
    error: {
        loadApp:
            "Errore nel caricamento della lista delle applicazioni. Riprova più tardi, grazie!",
    },
    layout: {
        footer: "© Linde 2018-",
    },
};
